export default __webpack_public_path__ + "static/media/quickiememecoin.5ad9fe98.png";